import OrganizationModel from "src/models/OrganizationModel";
import UserModel from "src/models/UserModel";
import renderEmail from "src/utils/renderEmail";

interface CustomerRequestReceivedEmailInput {
  accountOwner: UserModel;
  organization: OrganizationModel;
}

const CustomerRequestReceived = (vars) => ({
  type: `CustomerRequestReceived`,
  subject: `Customer Request Received - ${vars.organizationName}`,
  html: `<p>Dear ${vars.organizationName},</p>

<p>You’ve received a customer request from ${vars.accountName}. To manage it <a href="${vars.organizationUrl}">visit Captyn</a>.</p>

<p>Sincerely,<br />${vars.organizationName}</p>`,
  sms: `Customer request received from ${vars.accountName} ${vars.url}`,
});

export default ({
  accountOwner,
  organization,
}: CustomerRequestReceivedEmailInput) => {
  const template = CustomerRequestReceived;

  const variables = {
    organizationName: organization.title,
    organizationUrl: `https://${organization.subdomain}.captyn.com/admin`,
    accountName: `${accountOwner.firstName} ${accountOwner.lastName}`,
    url: `https://${organization.subdomain}.captyn.com/admin/pending`,
  };

  const email = renderEmail({ template, variables });

  return email;
};
